var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDFF",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Guide",
    transform: "translate(-70.000000, -1451.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(63.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/trophy",
    transform: "translate(4.000000, 1248.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25,5.99951172 L17,5.99951172 L17,4.74981689 C17,4.33429337 16.665625,4 16.25,4 L7.75,4 C7.334375,4 7,4.33429337 7,4.74981689 L7,5.99951172 L3.75,5.99951172 C3.334375,5.99951172 3,6.33380508 3,6.74932861 L3,8.49890137 C3,9.614254 3.703125,10.760849 4.934375,11.6450081 C5.91875,12.3542099 7.115625,12.8041 8.371875,12.9478149 C9.353125,14.5755424 10.5,15.2472534 10.5,15.2472534 L10.5,17.4967041 L9,17.4967041 C7.896875,17.4967041 7,18.1434212 7,19.2462769 L7,19.6211853 C7,19.8273849 7.16875,19.9960938 7.375,19.9960938 L16.625,19.9960938 C16.83125,19.9960938 17,19.8273849 17,19.6211853 L17,19.2462769 C17,18.1434212 16.103125,17.4967041 15,17.4967041 L13.5,17.4967041 L13.5,15.2472534 C13.5,15.2472534 14.646875,14.5755424 15.628125,12.9478149 C16.8875,12.8041 18.084375,12.3542099 19.065625,11.6450081 C20.29375,10.760849 21,9.614254 21,8.49890137 L21,6.74932861 C21,6.33380508 20.665625,5.99951172 20.25,5.99951172 Z M6.103125,10.0235291 C5.340625,9.47366333 5,8.86131287 5,8.49890137 L5,7.99902344 L7.00625,7.99902344 C7.0375,9.01752472 7.1875,9.91105652 7.40625,10.6921158 C6.934375,10.5296555 6.49375,10.3047104 6.103125,10.0235291 L6.103125,10.0235291 Z M19,8.49890137 C19,9.00190353 18.446875,9.62675095 17.896875,10.0235291 C17.50625,10.3047104 17.0625,10.5296555 16.590625,10.6921158 C16.809375,9.91105652 16.959375,9.01752472 16.990625,7.99902344 L19,7.99902344 L19,8.49890137 Z",
    id: "Mask",
    fill: "#858199",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrophy);
export default __webpack_public_path__ + "static/media/iconTrophy.c0174cde.svg";
export { ForwardRef as ReactComponent };